import mock from '@/fake-db/mock.js'

const data = {
  dispatchedOrders: [
    {
      orderNo: 101,
      status: 'confirmada',
      statusColor: 'success',
      operator: 'Cinar Knowles',
      operatorImg: require('@/assets/images/portrait/small/avatar-s-2.jpg'),
      usersLiked: [
        {
          name: 'Darcey Nooner',
          img: require('@/assets/images/portrait/small/avatar-s-8.jpg')
        }
      ],
      location: 'Cliniza en Zona 10',
      distance: '',
      distPercent: 80,
      startDate: '10:00 AM',
      estDelDate: '23/09/2020'
    },
    {
      orderNo: 102,
      status: 'Confirmada',
      statusColor: 'success',
      operator: 'Britany Ryder',
      operatorImg: require('@/assets/images/portrait/small/avatar-s-4.jpg'),
      usersLiked: [
        {
          name: 'Trina Lynes',
          img: require('@/assets/images/portrait/small/avatar-s-1.jpg')
        },
      ],
      location: 'Clínica en zona 10',
      distance: '',
      distPercent: 95,
      startDate: '11:00 AM',
      estDelDate: '21/09/2020'
    },
    {
      orderNo: 103,
      status: 'Pendiente',
      statusColor: 'warning',
      operator: 'Kishan Ashton',
      operatorImg: require('@/assets/images/portrait/small/avatar-s-1.jpg'),
      usersLiked: [ 
        {
          name: 'Jeffrey Gerondale',
          img: require('@/assets/images/portrait/small/avatar-s-9.jpg')
        }
      ],
      location: 'Clinica en Zona 10',
      distance: '',
      distPercent: 55,
      startDate: '12:00 PM',
      estDelDate: '25/09/2020'
    },
    {
      orderNo: 104,
      status: 'Cancelada',
      statusColor: 'danger',
      operator: 'Anabella Elliott',
      operatorImg: require('@/assets/images/portrait/small/avatar-s-6.jpg'),
      usersLiked: [ 
        {
          name: 'Elicia Rieske',
          img: require('@/assets/images/portrait/small/avatar-s-7.jpg')
        }
      ],
      location: 'Clinica en Zona 1',
      distance: '',
      distPercent: 5,
      startDate: '14:00 PM',
      estDelDate: '27/09/2020'
    }
  ]
}


mock.onGet('/api/table/dispatched-orders').reply(() => {
  return [200, data.dispatchedOrders]
})
